// Base
import { BaseApi } from '../base.api'

// Interface
import {
  INewsWebpageApi,
  INewsWebpageApiRequest,
  INewsWebpageApiGetAllAttrs,
  INewsWebpageApiGetAllResponse,
  INewsWebpageApiGetAttrs,
  INewsWebpageApiGetResponse,
} from 'interfaces/webpage/news/news-api.interface'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class NewsWebpageApi extends BaseApi<INewsWebpageApi> implements INewsWebpageApiRequest {
  readonly url = ApiConstant.NEWS_URL
  private newsUrl = axios_renderUrl(this.url, ApiConstant.WEBPAGE)

  /**
   * @description Get all news
   *
   * @method POST
   * @url ApiConstant.NEWS_URL
   * @access public
   *
   * @param {INewsWebpageApiGetAllAttrs} payload
   *
   * @return {Promise<INewsWebpageApiGetAllResponse>} Promise<INewsWebpageApiGetAllResponse>
   */
  async news_getAll(payload: INewsWebpageApiGetAllAttrs): Promise<INewsWebpageApiGetAllResponse> {
    try {
      const response = await this.POST(this.newsUrl, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get news
   *
   * @method POST
   * @url ApiConstant.NEWS_URL
   * @access public
   *
   * @param {INewsWebpageApiGetAttrs} payload
   *
   * @return {Promise<INewsWebpageApiGetResponse>} Promise<INewsWebpageApiGetResponse>
   */
  async news_get(payload: INewsWebpageApiGetAttrs): Promise<INewsWebpageApiGetResponse> {
    try {
      const response = await this.POST(`${this.newsUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
